import { useNavigate } from 'react-router-dom';
import Button from '@/components/ui/Button/Button';
import Card from '@/components/ui/Card/Card';
import Grid from '@/components/ui/Grid/Grid';
import Typography from '@/components/ui/Typography/Typography';
import icon from '@/assets/images/icon.svg';
import { styles } from './styles';

const NotFoundPage = () => {
    const navigate = useNavigate();

    return (
        <Grid container direction="column" alignItems="center" justifyContent="center">
            <Grid item>
                <Card sx={styles.card}>
                    <Grid container direction="column" alignItems="center" justifyContent="center">
                        <img width="212" style={styles.icon} src={icon} alt="Repair Exchange" />
                        <Typography variant="h1" m={2} p={2}>
                            There is nothing here...
                        </Typography>
                        <Typography variant="h3" m={2} p={2}>
                            404. Page Not Found
                        </Typography>
                        <Button
                            type="button"
                            color="secondary"
                            variant="contained"
                            onClick={() => navigate('/login')}
                            sx={styles.btn}
                        >
                            Login Page
                        </Button>
                    </Grid>
                </Card>
            </Grid>
            <Grid item>
                <Typography variant="h5" m={2} p={2}>
                    <strong>Repair</strong>Exchange
                </Typography>
            </Grid>
        </Grid>
    );
};

export default NotFoundPage;
